import * as React from 'react';

import { TOfferGeo } from '../../../types/offer';
import { isPrimaryMetroRegion } from '../../AddressContainer/helpers';

export const useUnderground = (geo?: TOfferGeo) => {
  const underground = React.useMemo(() => {
    if (!geo) {
      return undefined;
    }
    if (geo.undergrounds && isPrimaryMetroRegion(geo)) {
      const offerUndergrounds = geo.undergrounds
        .concat()
        .sort(({ time: timeA = 0 }, { time: timeB = 0 }) => timeA - timeB);

      return offerUndergrounds.find(underground => underground.isDefault) || offerUndergrounds[0];
    }

    return undefined;
  }, [geo]);

  return underground;
};
